<template>
    <NavBar />
    <NavigationError v-if="showNavigationError.show" />
    <router-view v-else />
</template>

<script setup lang="ts">
import { showNavigationError } from '../store/errorState';
import NavigationError from './components/NavigationError/NavigationError.vue';

</script>
